import { Box, SxProps, Theme, Typography } from "@mui/material";
import { SimpleRichText } from "src/components/common/rich-text/simple-rich-text";
import { ArrowLink } from "src/components-mui/base/arrow-link/arrow-link";
import { ISrc, ResponsiveImage } from "src/components-mui/base/responsive-image/responsive-image";
import { IImage, ILink } from "src/types/common";

interface IMediaContentCardProps {
    containerSx?: SxProps<Theme>;
    title: string;
    description: string;
    link: ILink;
    image: IImage | undefined;
    imageSx?: SxProps<Theme>;
    srcSet?: ISrc[];
    testId?: string;
    onLinkClick?: React.MouseEventHandler<HTMLAnchorElement>;
    onAuxClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

/**
 * MediaContentCard component displays content with image, title, description and call-to-action
 */
export const MediaContentCard = ({
    containerSx,
    imageSx = {},
    title,
    description,
    link,
    image,
    srcSet = [],
    testId,
    onLinkClick,
    onAuxClick,
}: IMediaContentCardProps) => (
    <Box
        display="flex"
        justifySelf="center"
        flexDirection="column"
        border="1px solid"
        borderRadius={1}
        p={2}
        sx={{ ...containerSx }}
        borderColor="gray.200"
        data-test-id={testId}
    >
        {image ? (
            <ResponsiveImage srcSet={srcSet} sx={{ borderRadius: 0.5, ...imageSx }} loading="eager" baseUrl={image?.url} alt={image.alt ?? ""} />
        ) : null}
        <Box pt={2}>
            <Typography fontWeight="fontWeightSemibold" component="h6">
                {title}
            </Typography>
            <SimpleRichText pt={1} fontSize="xs" text={description} />
        </Box>

        <Box pt={2} sx={{ ml: "auto", width: "fit-content" }}>
            <ArrowLink target={link.target} href={link.url} onClick={onLinkClick} onAuxClick={onAuxClick}>
                {link.name}
            </ArrowLink>
        </Box>
    </Box>
);
